import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import usePageMeta from '@/hooks/usePageMeta';
import useJsonLd, { websiteJsonLd } from '@/lib/jsonLd';
import Hero from './components/Hero';
import CategoryDropdown from './components/CategoryDropdown';
import CategoryGrid from './components/CategoryGrid';
import ShoppingCompanion from './components/ShoppingCompanion';
import WhyChooseUs from './components/WhyChooseUs';
import PillarArticles from './components/PillarArticles';
import FaqSection from './components/FaqSection';
import FinalCta from './components/FinalCta';

export default function Home() {
  const { t } = useTranslation();
  usePageMeta({
    title: t('hero.title'),
    description: t('hero.subtitle'),
    keywords:
      'AllChinaBuy Spreadsheet, AllChinaBuy finds, AllChinaBuy products, AllChinaBuy categories, AllChinaBuy buying guide',
    path: '/',
    type: 'website',
  });
  useJsonLd(websiteJsonLd());

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />

      <main>
        <Hero />

        <section id="categories" className="bg-white">
          <div className="mx-auto w-full max-w-7xl px-4 py-16 md:px-6 md:py-24">
            <div className="grid grid-cols-1 items-end gap-8 lg:grid-cols-2">
              <div>
                <span className="text-xs font-semibold uppercase tracking-widest text-primary-600">
                  {t('categories.badge')}
                </span>
                <h2 className="mt-2 font-heading text-3xl font-bold text-foreground-950 md:text-4xl">
                  {t('selector.title')}
                </h2>
              </div>
              <p className="text-sm leading-relaxed text-foreground-600 lg:text-right">
                {t('categories.intro')}
              </p>
            </div>

            <div className="mt-8">
              <CategoryDropdown />
            </div>

            <div className="mt-8">
              <CategoryGrid />
            </div>
          </div>
        </section>

        <ShoppingCompanion />
        <WhyChooseUs />
        <PillarArticles />
        <FaqSection />
        <FinalCta />
      </main>

      <Footer />
    </div>
  );
}